import { Pagination } from './pagination';
import { Lote } from './lote';

export class SearchResult {
   pagination: Pagination;
   lotes: Lote[];
}
